var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.747,
    height: 58.233,
    viewBox: "0 0 137.747 58.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-203.068 -47.35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.222,99.964,226.606,48.2a1.382,1.382,0,0,1,1.308-.846h.769a1.381,1.381,0,0,1,1.307.846l23.23,51.768a1.358,1.358,0,0,1-1.308,2h-3.077a1.413,1.413,0,0,1-1.307-.847l-5.692-12.691H214.529l-5.615,12.691a1.415,1.415,0,0,1-1.308.847h-3.077A1.358,1.358,0,0,1,203.222,99.964Zm36.537-16.307c-3.769-8.385-7.461-16.846-11.23-25.23h-.615l-11.231,25.23Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.146,61.2a13.279,13.279,0,0,1,11,5.384,1.505,1.505,0,0,1-.307,2.154l-1.463,1.23c-1.153,1.078-1.537.308-2.23-.307a9.492,9.492,0,0,0-7.077-3.231c-5.769,0-10.23,4.769-10.23,10.923s4.384,11.077,10.153,11.077c4.616,0,6.384-2.308,8.154-4,.923-.923,1.462-.77,2.308-.154l.845.615a1.549,1.549,0,0,1,.539,2.154A13.79,13.79,0,0,1,268.069,93.5,15.81,15.81,0,0,1,252.3,77.426,16.207,16.207,0,0,1,268.146,61.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.531,66.58h-3.922a1.46,1.46,0,0,1-1.461-1.461V63.426a1.414,1.414,0,0,1,1.461-1.461h3.922V53.427a1.513,1.513,0,0,1,1.462-1.462l2.462-.154a1.446,1.446,0,0,1,1.384,1.462v8.692h8.923a1.415,1.415,0,0,1,1.462,1.461v1.693a1.461,1.461,0,0,1-1.462,1.461h-8.923v18c0,3.077.769,3.693,2.539,3.693a14.7,14.7,0,0,0,5.615-1.692c1.154-.616,1.461-.155,1.846.461l1.154,1.923c.538.923.307,1.385-.539,1.923a20.1,20.1,0,0,1-8.845,2.615c-6.154,0-7.078-3.692-7.078-8.461Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.507,61.2c8.539,0,15.308,7.384,15.308,16.076,0,8.846-6.769,16.23-15.308,16.23S310.2,86.118,310.2,77.272C310.2,68.58,316.97,61.2,325.507,61.2Zm0,27.306c5.615,0,10-5,10-11.23,0-6.077-4.386-11-10-11s-10,4.923-10,11C315.507,83.5,319.892,88.5,325.507,88.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.076,105.583h-9.74a2.564,2.564,0,0,1,0-5.128h9.74a2.564,2.564,0,1,1,0,5.128Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e2bea264.svg";
export { ForwardRef as ReactComponent };